module.exports = __webpack_public_path__ + "img/firekeepers-daughter.d96e26e2.png";